import {
    api_url,
    legendLabelsBoxHeightLine,
    configChartsColorPalettes,
    yRight,
    partMobilityIndicators,
    popupInformation,
    defaultBarPercentage,
    defaultCategoryPercentage,
    defaultDatalabelsProperties,
    defaultTicksCustomValue,
} from "../../../utils";

const NbPersonnesMenage = {
    checked: false,
    titleSideBar: "Mobility Indicators Content.indicators.NbPersonnesMenage",
    titleIndicator: "Mobility Indicators Content.indicators.NbPersonnesMenage",
    popupInformation: {
        status: "false",
        text: popupInformation[partMobilityIndicators]["nbPersonnesMenage"],
    },
    keyFigure: {
        typeUpdate: "geographical_area", // year or geographical_area
        label: "",
        url: "",
        separator: "",
        position: "",
    },
    charts: [
        {
            typeChart: "bar",
            typeLabels: "geographical_areas", // years or geographical_areas
            multiYearGeographicalArea: true,
            singleYearGeographicalAreaType: "geographical_area", // year or geographical_area : MUST BE CONSISTENT WITH THE TYPE_LABEL ARGUMENT OF THE DATASET URL
            titleChart: "",
            titleDisplay: "true",
            legendDisplay: "false",
            legendCustom: "false",
            legendLabelsBoxHeight: legendLabelsBoxHeightLine,
            maintainAspectRatio: true,
            indexAxis: "x", // x or y
            heightChart: "250",
            widthChart: "600",
            i18nKeyLabels:
                "Mobility Indicators Content.charts.NbPersonnesMenage.axis.labelsX",
            scales: {
                x: {
                    type: "category",
                    display: true,
                    stacked: false,
                    titleDisplay: false,
                    titleText: "",
                    gridDisplay: false,
                    beginAtZero: false,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                y: {
                    type: "linear",
                    display: true,
                    stacked: false,
                    titleDisplay: true,
                    titleText: "",
                    gridDisplay: true,
                    beginAtZero: true,
                    max: null,
                    ticks: {
                        display: true,
                        value: defaultTicksCustomValue,
                    },
                },
                yRight: yRight,
            },
            annotationsProperties: {
                annotation1: undefined,
                annotation2: undefined,
            },
            keyFigure: {
                typeUpdate: "geographical_area", // year or geographical_area
                label: "",
                url: "",
                separator: "",
                position: "",
            },
            datasets: [
                {
                    type: "bar",
                    label: "",
                    data: [],
                    url:
                        api_url +
                        "charts/data/?part=mobility-indicators&type_label=cusco_geographical_areas&indicator=nb_personnes_menage&trend=projection&chart=nb_personnes_menage&schema_city=",
                    backgroundColor:
                        configChartsColorPalettes["0"].backgroundColor,
                    borderColor: configChartsColorPalettes["0"].borderColor,
                    borderWidth: 1,
                    pointStyle: "circle",
                    pointRadius: 3,
                    spanGaps: true,
                    legendCustomCssClass: "",
                    fill: false,
                    yAxisID: "y",
                    order: 2,
                    tooltipUnit: "",
                    barPercentage: defaultBarPercentage,
                    categoryPercentage: defaultCategoryPercentage,
                    datalabelsProperties: defaultDatalabelsProperties,
                },
            ],
        },
    ],
};

export default NbPersonnesMenage;
